import appConfig from "../app.config"

export default {
    computed : {
        settings(){
            return appConfig.settings || {}
        }
    }
}
